import { render, staticRenderFns } from "./not_any_role_home.vue?vue&type=template&id=6ef21957&scoped=true"
import script from "./not_any_role_home.vue?vue&type=script&lang=js"
export * from "./not_any_role_home.vue?vue&type=script&lang=js"
import style0 from "./not_any_role_home.vue?vue&type=style&index=0&id=6ef21957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef21957",
  null
  
)

export default component.exports